import { apiFetch } from './client';

const BASE = '/connector-attribute-mappings';

/**
 * List connector attribute mappings (paged). Scoped server-side to the
 * caller's tenant/subscription — no subscription id is sent here.
 * @param {{page?:number,size?:number,signal?:AbortSignal}} [opts]
 */
export const list = ({ page = 0, size = 20, signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}`, { signal });

/** Get a connector attribute mapping by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/**
 * Create a connector attribute mapping. Requires data_class_attribute_id,
 * direction ('OUTBOUND'|'INBOUND') and vendor_field. Do not send
 * connector_subscription_id — the server derives it from the caller's tenant.
 */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a connector attribute mapping. Absent fields are left untouched. */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a connector attribute mapping. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });
